/*
  ## System Colors ##
*/

export const COLOR = Object.freeze({
  GREEN_1: '#2B938A',
  GREEN_2: '#217B73',
  GREEN_3: '#d3ffd5',
  BLUE_1: '#1F2A47',
  BLUE_2: '#BBDEFB',
  GREY_1: '#464D5C',
  GREY_2: '#838383',
  GREY_3: '#C8CBD4',
  GREY_4: '#949494',
  GREY_5: '#A3A3A3',
  WHITE_1: '#FDFDFF',
  WHITE_2: '#F2F2F2',
  WHITE_3: '#FAFBFE',
  WHITE_4: '#FCFCFC',
  WHITE_5: '#F9F9F9',
  RED_1: '#f44336',
  RED_2: '#FBD6CB',
  RED_3: '#D71A1A',
  CORAL_1: '#FF5B5B',
  CORAL_2: '#B34B4B',
  YELLOW_1: '#fbf6cb',
});
